import { Component } from '@angular/core';
import { IconoirInfoCircle } from '@ey-xd/motif-icon';
import { MotifIconModule } from '@ey-xd/ng-motif';

@Component({
  selector: 'app-tb-instructions',
  standalone: true,
  imports: [MotifIconModule],
  templateUrl: './tb-instructions.component.html',
  styleUrl: './tb-instructions.component.scss',
})
export class TbInstructionsComponent {
  IconoirInfoCircle = IconoirInfoCircle;
}
